import React, { Fragment, useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Drawer,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  CardHeader,
  Avatar,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Button,
  CardActionArea,
  Typography
} from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import { useHistory } from "react-router-dom"
import { toggleDrawer } from "actions/drawers"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
// import PeopleAltIcon from "@material-ui/icons/PeopleAlt"
import HomeIcon from "@material-ui/icons/Home"
import StarIcon from "@material-ui/icons/Star"
import DoubleCheck from "components/Icons/DoubleCheck"
import SettingsIcon from "@material-ui/icons/Settings"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"
import AccountCircle from "@material-ui/icons/AccountCircle"
import SwapHorizIcon from "@material-ui/icons/SwapHoriz"
import AddIcon from "@material-ui/icons/Add"
import { logout } from "actions/authentication"
import cloudinary from "cloudinary-core"
import logoText from "assets/blue_firstline_social.png"
import packageTest from "../../../package.json"
import { isPWA } from "utils/isPWA"
import { getCurrentOrg } from "actions/organization"
import { openUpdateUserDialogFromProfile } from "actions/update-user-dialog"
import PersonIcon from "@material-ui/icons/Person"
import TocIcon from "@material-ui/icons/Toc"
import jwtDecode from "jwt-decode"
import ChatIcon from "@material-ui/icons/Chat"
import { getPosts, receivedPosts } from "actions/posts"

// console.log("isPWA:", isPWA())
const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const AppDrawer = ({ classes }) => {
  const dispatch = useDispatch()
  const {
    currentOrg,
    orgs = [],
    user,
    open,
    token,
    authenticatedUser
  } = useSelector(state => ({
    currentOrg: state.organization.currentOrg,
    orgs: state.authentication.authenticatedUser.user_orgs,
    user: state.authentication.authenticatedUser,
    userTitle: state.authentication.authenticatedUser.title_value,
    open: state.drawers.appDrawer,
    token: state.authentication.token,
    authenticatedUser: state.authentication.authenticatedUser
  }))
  const [isSuperUser, setIsSuperUser] = useState(false)
  const history = useHistory()
  const [currentPath, setCurrentPath] = useState(
    window.location.pathname.split("/")[1]
  )

  useEffect(() => {
    if (token) {
      try {
        const isSuperUser = jwtDecode(token).su
        setIsSuperUser(Boolean(isSuperUser))
      } catch (err) {
        console.log(err)
      }
    }
  }, [token])

  useEffect(() => {
    setCurrentPath(window.location.pathname.split("/")[1])
  }, [window.location.pathname])

  const handleToggleDrawer = () => {
    dispatch(toggleDrawer())
  }

  const handleLogout = () => {
    dispatch(toggleDrawer())
    dispatch(logout())
  }

  const handleClick = path => {
    dispatch(toggleDrawer())
    // setTimeout to delay push to allow drawer to close
    setTimeout(() => {
      history.push(`${path}`)
    }, 500)
  }

  // Checks if url currently has subdomain and then redirects accordingly
  const handleOrgClick = org => {
    // console.log({ org })
    if (isPWA()) {
      // console.log("Getting org...")
      dispatch(getCurrentOrg(org.org_id)).then(res => {
        dispatch(toggleDrawer())
        // setTimeout to delay push to allow drawer to close
        setTimeout(() => {
          history.push(`/app/feed/`)
          dispatch(getPosts("feed"))
        }, 500)
      })
    } else {
      const host = window.location.host.split(".")

      // Reset posts when changing orgs
      // dispatch(receivedPosts({}))

      if (host.length === 3) {
        window.location = `http://${org.subdomain}.${host[1]}.${host[2]}/app/feed?token=${token}&user=${user.id}`
      } else {
        window.location = `http://${org.subdomain}.${host[0]}.${host[1]}/app/feed?token=${token}&user=${user.id}`
      }
    }
  }

  let bodyPage = document.body
  useEffect(() => {
    if (open) {
      bodyPage.style.position = "fixed"
      bodyPage.style.top = `-${window.scrollY}px`
    } else {
      bodyPage.style.position = ""
      bodyPage.style.top = ""
    }
  }, [open])

  const appMenu = [
    {
      title: "My Organization",
      icon: <HomeIcon className={classes.iconColor} />,
      path: "/app/feed"
    },
    {
      title: "My Submitted",
      icon: <StarIcon className={classes.iconColor} />,
      path: "/app/submitted"
    },
    {
      title: "My Published",
      icon: (
        <DoubleCheck className={classes.iconColor} style={{ fontSize: 21 }} />
      ),
      path: "/app/published"
    }
  ]

  const adminMenu = [
    {
      title: "Recent Posts",
      icon: <StarIcon className={classes.iconColor} />,
      path: "/admin/recentposts"
    },
    {
      title: "Organizations",
      icon: <HomeIcon className={classes.iconColor} />,
      path: "/admin/organizations"
    },
    {
      title: "Members",
      icon: <AccountCircle className={classes.iconColor} />,
      path: "/admin/members"
    },
    {
      title: "Settings",
      icon: <SettingsIcon className={classes.iconColor} />,
      path: "/admin/settings"
    },
    {
      title: "Communication",
      icon: <ChatIcon fontSize="small" className={classes.iconColor} />,
      path: "/admin/communication"
    }
  ]

  let initalCurrentAddress = ""
  if (currentOrg.address) {
    try {
      initalCurrentAddress =
        JSON.parse(currentOrg.address).city +
        ", " +
        JSON.parse(currentOrg.address).state
    } catch (err) {
      console.log(err)
    }
  }

  const initalOrgAddressFunction = address => {
    let initialOrgAddress = ""
    if (address) {
      try {
        initialOrgAddress =
          JSON.parse(address).city + ", " + JSON.parse(address).state
      } catch (err) {
        console.log(err)
      }
    }
    return initialOrgAddress
  }
  const {
    first_name: firstName,
    last_name: lastName,
    phone,
    email,
    id
    // profile_image
  } = authenticatedUser

  const handleOpenUpdateUser = () => {
    dispatch(toggleDrawer())
    dispatch(
      openUpdateUserDialogFromProfile({ firstName, lastName, phone, email, id })
    )
  }

  let newCurrentOrgName = ""
  try {
    if (currentOrg.name && currentOrg.name.length > 16) {
      newCurrentOrgName = currentOrg.name.slice(0, 16) + "..."
    } else {
      newCurrentOrgName = currentOrg.name
    }
  } catch (err) {
    console.log(err)
  }

  return (
    <Fragment>
      <Drawer
        open={open}
        onClose={handleToggleDrawer}
        PaperProps={{ className: classes.drawerPaper }}
        anchor="left"
      >
        <Box className={classes.drawer} role="nav">
          <CardHeader
            className={classes.user}
            avatar={
              <Avatar
                aria-label="Profile"
                className={classes.avatarProfile}
                src={cl.url(user.profile_image, {
                  width: 150,
                  crop: "scale"
                })}
              >
                {user.first_name ? user.first_name.split("").splice(0, 1) : ""}
                {user.last_name ? user.last_name.split("").splice(0, 1) : ""}
              </Avatar>
            }
            title={`${user.first_name} ${user.last_name}`}
            titleTypographyProps={{ className: classes.userTitle }}
            subheader={
              currentOrg.user_title_value ? currentOrg.user_title_value : ""
            }
            subheaderTypographyProps={{ className: classes.userSubTitle }}
          />
          {currentOrg && currentOrg.role_id < 4 && (
            <List>
              <ListItem
                button
                onClick={() => {
                  const path = currentPath === "admin" ? "/app" : "/admin"
                  handleClick(path)
                }}
              >
                <ListItemIcon>
                  <SwapHorizIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText
                  className={classes.listItemTextColor}
                  primary={
                    currentPath === "admin" ? "Go To App" : "Go To Admin"
                  }
                />
              </ListItem>
            </List>
          )}
          <ExpansionPanel className={classes.orgPanel}>
            <ExpansionPanelSummary
              className={classes.selectedOrgContainer}
              expandIcon={<ExpandMoreIcon className={classes.iconColor} />}
              aria-controls="drawer"
              id="drawer"
            >
              <CardHeader
                className={classes.selectedOrg}
                avatar={
                  <Avatar
                    src={
                      currentOrg.logo &&
                      cl.url(JSON.parse(currentOrg.logo).public_id, {
                        width: 150,
                        crop: "scale"
                      })
                    }
                    variant="square"
                    aria-label="Organization"
                    className={classes.avatarSelectedOrg}
                  />
                }
                title={newCurrentOrgName}
                subheader={initalCurrentAddress}
              />
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.orgList}>
              {orgs.length &&
                orgs
                  .filter(org => org.org_id !== currentOrg.id)
                  .map((org, i) => {
                    return (
                      <CardActionArea
                        onClick={() => handleOrgClick(org)}
                        key={i}
                      >
                        <CardHeader
                          className={classes.notSelectedOrg}
                          avatar={
                            <Avatar
                              variant="square"
                              aria-label="Organization"
                              className={classes.avatarOrg}
                              src={
                                org.logo &&
                                cl.url(JSON.parse(org.logo).public_id, {
                                  width: 150,
                                  crop: "scale"
                                })
                              }
                            />
                          }
                          title={
                            org.name.length > 16
                              ? org.name.slice(0, 16) + "..."
                              : org.name
                          }
                          subheader={initalOrgAddressFunction(org.address)}
                        />
                      </CardActionArea>
                    )
                  })}
            </ExpansionPanelDetails>
            <Box
              className={classes.addOrg}
              onClick={() => handleClick("/app/add-org")}
            >
              <Button>
                <AddIcon className={classes.addIcon} /> Add Organization
              </Button>
            </Box>
          </ExpansionPanel>
          <Divider />
          <List>
            {(currentPath === "admin" ? adminMenu : appMenu).map(
              (item, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleClick(item.path)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    className={classes.listItemTextColor}
                  />
                </ListItem>
              )
            )}
            {isSuperUser && (
              <ListItem
                button
                key={"Administrator}"}
                onClick={() => handleClick("/superadmin")}
              >
                <ListItemIcon>
                  <TocIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText
                  primary={"Administrator"}
                  className={classes.listItemTextColor}
                />
              </ListItem>
            )}
          </List>
          <Divider />
          <List>
            <ListItem
              button
              key={"Edit Profile}"}
              onClick={handleOpenUpdateUser}
            >
              <ListItemIcon>
                <PersonIcon className={classes.iconColor} />
              </ListItemIcon>
              <ListItemText
                primary={"Edit Profile"}
                className={classes.listItemTextColor}
              />
            </ListItem>
            <ListItem
              className={classes.logoutContainer}
              button
              onClick={handleLogout}
            >
              <ListItemIcon>
                <ExitToAppIcon className={classes.iconColor} />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                className={classes.listItemTextColor}
              />
            </ListItem>
          </List>
          <List className={classes.drawerBottom}>
            {currentOrg.white_labeled === 0 && (
              <Box className={classes.logoTextContainer}>
                <img
                  className={classes.logoText}
                  src={logoText}
                  alt="FirstLine Social"
                />
              </Box>
            )}
            <Typography className={classes.version}>
              {packageTest.version}
            </Typography>
          </List>
        </Box>
      </Drawer>
    </Fragment>
  )
}

export default withStyles(styles)(AppDrawer)



// WEBPACK FOOTER //
// ./src/components/AppDrawer/index.js